<template>
    <div>
        <div class="row">
            <div class="col-md-12">
              <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link :to="{ name: 'home' }">{{
                      $t("inicio")
                    }}</router-link>
                  </li>
                  <li class="breadcrumb-item">
                    <router-link :to="{ name: 'informes' }">{{
                      $t("informes")
                    }}</router-link>
                  </li>
                  <li class="breadcrumb-item">
                    <router-link :to="{ name: 'informe-pedidos' }">{{
                      $t("informePedidos")
                    }}</router-link>
                  </li>
                  <li class="breadcrumb-item active" aria-current="page">
                      {{$t("informePedidosDetalle")}}
                  </li>
                </ol>
              </nav>
            </div>

            <!--<CabeceraInformes
              :idBusiness="idBusiness"
              :listBusinesses="listBusinesses"
              :idTpv="idTpv"
              :listTpv="listTpv"
              :dateto="dateto"
              :datefrom="datefrom"
              id="cabecera"
              :conTodos="true"
            />-->

            <div class="col-md-12" v-if="respuesta">
                <template v-if="dateInform.length > 0"> <!-- comprueba el tamaño del array del informe de pedidos-->
                    <div class="row justify-content-between div-export">
                        <div class="col-md-12 text-left">
                            <!-- <el-dropdown>
                                <el-button type="primary" size="small">
                                    <i class="fa fa-file"></i>
                                        {{ $t("exportarInforme") }}
                                    <i class="el-icon-arrow-down el-icon--right"></i>
                                </el-button>
                                <el-dropdown-menu slot="dropdown">
                                   <a :href="urlExportPDF">
                                        <el-dropdown-item class="text-danger">
                                        <strong>
                                            <i class="fa fa-file-pdf"></i> {{ $t("exportarPdf") }}
                                        </strong>
                                    </el-dropdown-item>
                                   </a>
                                    <a :href="urlExportExcel">
                                    <el-dropdown-item class="text-success">
                                        <strong> 
                                            <i class="fa fa-file-excel"></i> {{ $t("exportarExcel") }}
                                        </strong>
                                    </el-dropdown-item>
                                     </a>
                                </el-dropdown-menu>
                            </el-dropdown> -->
                            <!-- <router-link :to="{name:'informe-pedidos'}">
                                <el-button type="primary" size="large" >
                                        <i class="el-icon-back el-icon--left" style="margin-left:0px; padding-left:0px;"></i> 
                                        {{ $t("volver") }}
                                    </el-button>
                            </router-link>     -->

                        </div>
                    </div>

                    <div class="table-responsive" style="overflow: auto">
                        <table class="table table-bordered table-striped text-nowrap">
                                <thead class="thead-dark">
                                    <tr>
                                        <th>
                                            <span
                                            v-if="ordenarDate"
                                            @click="sortedArrayASC(1), (ordenarDate = 0)"
                                            ><i style="color: white" class="fa fa-angle-up"></i>
                                            {{ $t("fecha") }}
                                            </span>
                                            <span v-else @click="sortedArrayDESC(1), (ordenarDate = 1)"
                                            ><i style="color: white" class="fa fa-angle-down"></i>
                                            {{ $t("fecha") }}
                                            </span>
                                        </th>
                                        <th>
                                            <span
                                            v-if="ordenarTipoPedido"
                                            @click="sortedArrayASC(2), (ordenarTipoPedido = 0)"
                                            ><i style="color: white" class="fa fa-angle-up"></i>
                                            {{ $t("tipoPago") }}
                                            </span>
                                            <span
                                            v-else
                                            @click="sortedArrayDESC(2), (ordenarTipoPedido = 1)"
                                            ><i style="color: white" class="fa fa-angle-down"></i>
                                            {{ $t("tipoPedido") }}
                                            </span>
                                        </th>
                                        <th>
                                            <span
                                            v-if="ordenarTipoPago"
                                            @click="sortedArrayASC(3), (ordenarTipoPago = 0)"
                                            ><i style="color: white" class="fa fa-angle-up"></i>
                                            {{ $t("tipoPago") }}
                                            </span>
                                            <span
                                            v-else
                                            @click="sortedArrayDESC(3), (ordenarTipoPago = 1)"
                                            ><i style="color: white" class="fa fa-angle-down"></i>
                                            {{ $t("tipoPago") }}
                                            </span>
                                        </th>
                                        <th>
                                            <span
                                            v-if="ordenarAmount"
                                            @click="sortedArrayASC(4), (ordenarAmount = 0)"
                                            ><i style="color: white" class="fa fa-angle-up"></i>
                                            {{ $t("importe") }}
                                            </span>
                                            <span
                                            v-else
                                            @click="sortedArrayDESC(4), (ordenarAmount = 1)"
                                            ><i style="color: white" class="fa fa-angle-down"></i>
                                            {{ $t("importe") }}
                                            </span>
                                        </th>
                                        <th>{{ $t("acciones") }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="obj in dateInform">
                                        <td>{{ obj.date | parseDateMin }}</td>
                                    
                                        <td v-if="obj.tipoPedido === 'D'" >{{ $t("domicilio") }}</td>
                                        <td v-else-if="obj.tipoPedido === 'R'"> {{ $t("recoger")}}</td>

                                        <td v-if="obj.formaPago===null">{{ $t("pagoLocal")}}</td>
                                        <td v-else-if="obj.formaPago!=null">{{ obj.formaPago }}</td>

                                        <td align="left">{{ obj.amount | currency }}</td>

                                        <td align="center">

                                          <div class="btn btn-primary btn-link">
                                          <i
                                            @click="getDetTicketsById(obj.idHeader, obj.idCodeHeader)"
                                            v-tooltip.top-center="$i18n.t('verDetallesDetTicket')"
                                            class="fa fa-eye text-primary"
                                          ></i>
                                        </div>
                                            <!-- <div class="btn btn-primary btn-link text-success">
                                            <a :href="urlExportTicketExcel(obj.idHeader, obj.idTpv)">
                                                <i
                                                v-tooltip.top-center="$i18n.t('exportarExcel')"
                                                class="fa fa-file-excel text-success"
                                                ></i
                                            ></a>
                                            </div>
                                    
                                        <div class="btn btn-primary btn-link text-danger">
                                            <a
                                                :href="urlExportTicketPDFReal(obj.idHeader, obj.idTpv)"
                                            >
                                                <i
                                                v-tooltip.top-center="$i18n.t('exportarPdf')"
                                                class="fa fa-file-pdf text-danger"
                                                ></i>
                                            </a>
                                            </div> -->
                                        </td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr class="table-success">
                                        <td colspan="4" class="table-success">
                                            <strong>{{ $t("total") }}:</strong>
                                        </td>
                                        <td class="text-right">
                                            <strong>
                                            {{ getTotalVentas | currency }}
                                            </strong>
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                </template>
                <template v-else>
                    <div class="alert alert-danger" role="alert">
                        {{ $t("noHayFacturasEmitidasEnEsteRangoDeFecha") }}
                    </div>
                </template>
            </div>
        </div>
            <modal
              name="desglose-ticket-modal"
              :adaptive="true"
              :scrollable="true"
              height="auto"
              :clickToClose="false"
            >
              <div>
                <div class="modal-header">
                  <h4 style="margin: 0px">
                    {{ $t("desgloseDelTicket") }} {{ nameTickets }}
                  </h4>
                </div>
                <div class="modal-body">
                  <ticket :ticket="listDesgloseTicket"></ticket>
                </div>
                <div class="modal-footer">
                  <button class="btn btn-default" @click="cerrarModal()">
                    <i class="fa fa-times-circle"></i>
                    {{ $t("volver") }}
                  </button>
                </div>
              </div>
            </modal>
    </div>
</template>
<script>
import Datepicker from "vuejs-datepicker";
import {
  DatePicker,
  Select,
  Option,
  Dropdown,
  Loading,
  DropdownItem,
  DropdownMenu,
  Button,
} from "element-ui";
import swal from "sweetalert2";
import moment from "moment";
import Breadcrumb from "@/components/Breadcrumb/Breadcrumb.vue";
import CabeceraInformes from "@/components/CabeceraInformes/CabeceraInformes.vue";
import Ticket from "../../../Widgets/Ticket.vue";
import Datetime from "vue-datetime";

export default {
    created() {
    this.datefrom = this.$route.params.datefrom;
    this.dateto = this.$route.params.dateto;
    this.hoursfrom = this.$route.params.hoursfrom;
    this.hoursto = this.$route.params.hoursto;
    this.idBusiness = this.$route.params.idBusiness;
    
    //console.log('params: ' + JSON.stringify(this.$route.params));
    // console.log('params: ' + this.$route.params.idDay, this.$route.params.idBusiness, this.$route.params.datefrom, this.$route.params.dateto, this.$route.params.hoursfrom, this.$route.params.hoursto);

    // console.log("HOURSFROM: " + JSON.stringify(this.$store.getters));

    ///this.loading = Loading.service({ text: "Cargando..." });
    this.$store.dispatch("setNameRoute", this.$i18n.t("informePedidosDetalle"));
    this.getPedidosArchivados();

  },
   components: {
    [DatePicker.name]: DatePicker,
    [Select.name]: Select,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Button.name]: Button,
    [Datetime]: Datetime,
    [Option.name]: Option,
    Breadcrumb,
    CabeceraInformes,
    Ticket
  },
    data() {
      return {
      loading: false,
      datefrom: new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          1
      ).toISOString(),
      dateto: new Date().toISOString(),
      value4: [
          new Date(new Date().getFullYear(), new Date().getMonth(), 1),
          new Date(),
      ],
      //hoursfrom: new Hours(
       // new Hours().getHour(),
      //  new Hours().getMinute(),
      //  1
      //).toISOString(),
      //hoursto: new Hours().toISOString(),
      //value4: [
      //  new Hours(new Hours().getHour(), new Hours().getMinute(), 1),
      //  new Hours,
      //],
      listBusinesses: [],
      idBusiness: this.$route.params.idBusiness,
      idTpv: 0,
      data: [""],
      listTpv: [],
      cuentasAparcadas: false,
      dateInform: ["-"],
      indice: 0,
      idDay: null,
      listDesgloseTicket: [],
      nameTickets: "",
      //ORDEN
      ordenarDate: 0,
      ordenarTipoPedido: 0,
      ordenarTipoPago: 0,
      ordenarAmount: 0,

      respuesta: true,
    };
  },
  computed: {

      urlExportPDF() {
      return (
        this.$store.getters.apiUrl +
        "/sales/exportFacturasEmitidasPedidos/PDF?idTpv=" +
        this.idTpv +
        "&idBusiness=" +
        this.idBusiness +
        "&idTpv=" +
        this.idTpv +
        "&datefrom=" +
        moment(this.datefrom)
          .startOf("day")
          .unix() +
        "&dateto=" +
        moment(this.dateto)
          .endOf("day")
          .unix() +
        // "&hoursfrom=" +
        // moment(this.hoursfrom)
        //   .startOf("hour")
        //   .unix() +
        // "&hoursto=" +
        // moment(this.hoursto)
        //   .endOf("hour")
        //   .unix() +
        "&jwt=" +
        this.$store.getters.jwt
      );
    },
        urlExportExcel() {


      return (
        this.$store.getters.apiUrl +
        "/sales/exportFacturasEmitidasPedidos/Excel?idTpv=" +
        this.idTpv +
        "&idBusiness=" +
        this.idBusiness +
        "&idTpv=" +
        this.idTpv +
        "&datefrom=" +
        moment(this.datefrom)
          .startOf("day")
          .unix() +
        "&dateto=" +
        moment(this.dateto)
          .endOf("day")
          .unix() +
        // "&hoursfrom=" + 
        // moment(this.hoursfrom)
        //   .startOf("hour")
        //   .unix() +
        // "&hoursto=" +
        // moment(this.hoursto)
        //   .endOf("hour")
        //   .unix() +
        "&jwt=" +
        this.$store.getters.jwt
      );
    },getTotalVentas() {
      let xtotal = 0;

      this.dateInform.forEach(function(x) {
        xtotal += x.amount;
      });
    
      return xtotal;
    },

  },

  methods: {
       sortedArrayASC: function(nameAtributo) {
      switch (nameAtributo) {
        case 1:
          this.ordenarDate = 1;

          function compareDate(a, b) {
            if (a.date < b.date) return -1;
            if (a.date > b.date) return 1;
            return 0;
          }

          return this.dateInform.sort(compareDate);

        case 2:
          this.ordenarTipoPedido = 1;

          function comparetipoPedido(a, b) {
            if (a.tipoPedido.toUpperCase() < b.tipoPedido.toUpperCase()) return -1;
            if (a.tipoPedido.toUpperCase() > b.tipoPedido.toUpperCase()) return 1;
            return 0;
          }

          return this.dateInform.sort(comparetipoPedido);

        case 3:
          this.ordenarTipoPago = 1;

          function comparePaidType(a, b) {
            if (a.formaPago < b.formaPago) return -1;
            if (a.formaPago > b.paiformaPagodType) return 1;
            return 0;
          }

          return this.dateInform.sort(comparePaidType);

    
        case 4:
          this.ordenarAmount = 1;

          function compareAmount(a, b) {
            if (a.amount < b.amount) return -1;
            if (a.amount > b.amount) return 1;
            return 0;
          }

          return this.dateInform.sort(compareAmount);
      }
    },
     sortedArrayDESC: function(nameAtributo) {
      switch (nameAtributo) {
        case 1:
          this.ordenarDate = 0;

          function compareDate(a, b) {
            if (a.date > b.date) return -1;
            if (a.date < b.date) return 1;
            return 0;
          }

          return this.dateInform.sort(compareDate);

        case 2:
          this.ordenarTipoPedido = 0;

          function comparePaidType(a, b) {
            if (a.tipoPedido > b.tipoPedido) return -1;
            if (a.tipoPedido < b.tipoPedido) return 1;
            return 0;
          }

          return this.dateInform.sort(comparePaidType);

          
        case 3:
          this.ordenarTipoPago = 0;

          function comparePaidType(a, b) {
            if (a.formaPago > b.formaPago) return -1;
            if (a.formaPago < b.formaPago) return 1;
            return 0;
          }

          return this.dateInform.sort(comparePaidType);

        case 4:
          this.ordenarAmount = 0;

          function compareAmount(a, b) {
            if (a.amount > b.amount) return -1;
            if (a.amount < b.amount) return 1;
            return 0;
          }

          return this.dateInform.sort(compareAmount);
      }
    },

    //  getBusiness() {
    //   var config = {
    //     params: {
    //       jwt: this.$store.getters.jwt,
    //     },
    //     headers: { Authorization: "Bearer " + this.$store.getters.jwt },
    //   };

    //   let vm = this;
    //   this.axios
    //     .get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
    //     .then(function(response) {
    //       vm.listBusinesses = response.data.result;

    //       if (vm.$store.getters.idBusiness) {
    //         //vm.idBusiness = vm.$store.getters.idBusiness;
    //       } else {
    //         //vm.idBusiness = response.data.result[0].id;
    //       }

    //       vm.cambioTpv(-1, false);
        
    //     })
    //     .catch(function(error) {
    //       console.log(error);
    //     });
    // },

      cambioBusiness(idBusinessData, listTpv) {
      if (listTpv) {
        this.listTpv = listTpv;
      }
      this.loading = Loading.service({ text: "Cargando..." });
      //this.idBusiness = idBusinessData;
      this.idTpv = -1;
      this.list = [];
      this.cambioTpv()
    },
    emitirConsulta() {
      this.getPedidosArchivados();
    },
    cambioTpv(idTpvData, filtrar) {
      this.idTpv = idTpvData;
      this.emitirConsulta();
    },
    cambioHora(dates) {
      this.datefrom = dates[0];
      this.dateto = dates[1];
    },

    getTpv() {
      this.listTpv = [];

      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getTpvsByBusiness", config)
        .then(function(response) {
          if (response.data.response) {
            vm.listTpv = response.data.result;
            if (vm.listTpv.length > 0) {
              vm.idTpv = vm.listTpv[0].id;
              vm.getPedidosArchivados();
            }
          }
        })
        .catch(function(error) {
          console.log(error);
        })
        .finally((_) => {
          vm.loading.close();
        });
    },
 getPedidosArchivados() {
  
  this.idDay = this.$route.params.idDay;
  const initDate = 0;
  const endDate = 0;

  // this.dateto=initDate
  // this.datefrom=endDate

      if (this.datefrom === null || this.dateto === null || this.idDay == null) {
        swal({
          title: this.$t("ups"),
          text: this.$t("seleccioneUnaFechaDeInicioYUnaFechaDeFin"),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
      } else {
        let secondsDesde = moment(this.datefrom).unix();
        let secondsHasta = moment(this.dateto).unix();


        if (secondsHasta < secondsDesde) {
          swal({
            title: this.$t("ups"),
            text: this.$t("laFechaDeInicioNoPuedeSerPosteriorALaDeFin"),
            confirmButtonClass: "btn btn-info btn-fill",
            type: "error",
          });
        } else {
          //this.$store.dispatch("setDateTo", this.dateto);
          //this.$store.dispatch("setDateFrom", this.datefrom);

          //esto esta comentado porque falla al sobreescribir la fecha en este archivo en concreto, al hacer la redireccion en el boton
          //volver lo devuelve cono undefined y peta en el archivo de informes

          this.loading = Loading.service({ text: "Cargando..." });

          let busquedaHoras = false;

          if (this.hoursfrom && this.hoursto) {
            busquedaHoras = true;
          }

          if (busquedaHoras) {
            //Se crea el array list donde separamos la cadena de las horas en horas, minutos y segundos
            const f = this.hoursfrom.split(':');
            const t = this.hoursto.split(':');

            //Montamos las fechas con la cadena de los días que recibimos
            const from = new Date(this.datefrom);
            const to = new Date(this.dateto);
            
            //Metemos las horas recibidas en las fechas
            from.setHours(f[0], f[1], f[2]);
            to.setHours(t[0], t[1], t[2]);

            var config = {
              params: {
                idBusiness: this.idBusiness,
                idTpv: this.idTpv,
                idDay:this.idDay,
                datefrom: (new Date(from.toISOString())).getTime(),
                dateto: (new Date(to.toISOString())).getTime(),
                hoursto: (this.hoursto),
                hoursfrom: (this.hoursfrom),
                jwt: this.$store.getters.jwt,
              },
              headers: { Authorization: "Bearer " + this.$store.getters.jwt },
            };
          } else {
            var config = {
              params: {
                idBusiness: this.idBusiness,
                idTpv: this.idTpv,
                idDay:this.idDay,
                datefrom: moment(this.datefrom)
                .startOf("day")
                .unix(),
                dateto: moment(this.dateto)
                .endOf("day")
                .unix(),
                jwt: this.$store.getters.jwt,
              },
              headers: { Authorization: "Bearer " + this.$store.getters.jwt },
            };
          }
          

          //Obtenemos los minutos que hay de diferencia horaria
          /*const diffFrom = from.getTimezoneOffset();
          const diffTo = to.getTimezoneOffset();

          //Y se lo restamos a las fechas para así obtener las fechas con las que vamos a trabajar
          from.setMinutes(from.getMinutes() - diffFrom);
          to.setMinutes(to.getMinutes() - diffTo);*/

          

          let vm = this;
          this.$store.dispatch("setIdBusiness", this.idBusiness);
          this.axios
            .get(
              this.$store.getters.apiUrl + "sales/getPedidosArchivados",
              config
            )
            .then(function(response) {
              if (response.data.response) {
                vm.dateInform = response.data.result;
                vm.respuesta = true;
              } else {
                swal({
                  title: vm.$t("atencion"),
                  text: response.data.message,
                  confirmButtonClass: "btn btn-info btn-fill",
                  type: "error",
                });

                vm.respuesta = false;
              }
              vm.loading.close();
            })
            .catch(function(error) {
              console.log(error);
            });
        }
      }

    },
     getDetTicketsById(idHeader, name) {
      this.listDesgloseTicket = [];
      this.nameTickets = name;

      this.loading = Loading.service({ text: "Cargando..." });

      var config = {
        params: {
          idBusiness: this.idBusiness,
          idHeader: idHeader,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "sales/getDetTicketsById", config)
        .then(function(response) {
          if (response.data.response) {
            vm.listDesgloseTicket = response.data.result[0];
            vm.$modal.show("desglose-ticket-modal");
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.result,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
          vm.loading.close();
        })
        .catch(function(error) {
          console.log(error);
        });
    },
       openModal(idHeader) {
      this.getTicketsDet(idHeader);

      this.$modal.show("desgloseModal");
    },
      cerrarModal() {
      this.$modal.hide("desgloseModal");
      this.$modal.hide("desglose-ticket-modal");
    },
    urlExportTicketPDF(idHeader) {
      return (
        this.$store.getters.apiUrl +
        "/sales/exportFacturasEmitidasById/PDF?idBusiness=" +
        this.idBusiness +
        "&idHeader=" +
        idHeader +
        "&jwt=" +
        this.$store.getters.jwt
      );
    },
        urlExportTicketPDFReal(idHeader, idTpv) {
      return (
        this.$store.getters.apiUrl +
        "/sales/exportFacturasEmitidaById/PDF?idBusiness=" +
        this.idBusiness +
        "&idHeader=" +
        idHeader +
        "&idTpv=" +
        idTpv +
        "&jwt=" +
        this.$store.getters.jwt
      );
    },
    urlExportTicketExcel(idHeader, idTpv) {
      return (
        this.$store.getters.apiUrl +
        "/sales/exportFacturasEmitidasById/Excel?idBusiness=" +
        this.idBusiness +
        "&idHeader=" +
        idHeader +
        "&idTpv=" +
        idTpv +
        "&jwt=" +
        this.$store.getters.jwt
      );
    },

  },


}
</script>

<style scoped>

  .active-filter {
      color: #1E22AA;
      border-color: #b9d0d7;
      background-color: #e8eff2;
  }

  a li {
      color: #111;
  }

  .card {
      padding: 20px;
  }

  .div-export {
      margin-bottom: 10px;
  }

  .sunday {
      color: rgb(128, 0, 0);
  }

  .fridaySaturday {
      color: rgb(0, 128, 64);
  }

  .trDay:hover {
      background-color: rgba(68, 125, 247, 0.2) !important;
  }

</style>


// WEBPACK FOOTER //
// src/pages/Dashboard/Informes/Pedidos/InformePedidosDetalle.vue